type InputAreaProps = {
  value?: string | number;
  className?: string;
  loading: boolean;
  input: any;
  disabled?: boolean;
  dataTest?: string;
};

const InputArea = ({ value, className, loading, input, disabled, dataTest }: InputAreaProps) => {
  return (
    <input
      value={value}
      name="item_quantity"
      className={className}
      inputMode="numeric"
      min="0"
      max="100000"
      step="1"
      placeholder="0"
      tabIndex={-1}
      readOnly={loading}
      {...input}
      disabled={disabled}
      data-test={dataTest}
    />
  );
};

export default InputArea;
